var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.26062 0 0 4.26062 0 9.5C0 14.7394 4.26062 19 9.5 19C14.7394 19 19 14.7394 19 9.5C19 4.26062 14.7394 0 9.5 0ZM9.5 1.2392C14.0697 1.2392 17.7609 4.93041 17.7609 9.50007C17.7609 14.0697 14.0697 17.7609 9.5 17.7609C4.93034 17.7609 1.23913 14.0697 1.23913 9.50007C1.23913 4.93041 4.93034 1.2392 9.5 1.2392ZM9.5 2.68482C9.15786 2.68482 8.8804 2.96227 8.8804 3.30442V9.50007C8.8804 9.84221 9.15785 10.1197 9.5 10.1197H15.2826C15.6247 10.1197 15.9022 9.84236 15.9022 9.50007C15.9022 9.15794 15.6248 8.88047 15.2826 8.88047H10.1196V3.30438C10.1196 2.96225 9.84225 2.68478 9.49996 2.68478L9.5 2.68482Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.2c260e61795c898c5936caffbf1a1f95.svg";
export { ForwardRef as ReactComponent };